export default "__VITE_ASSET__DzZ6$p5o__"